export function formatUnit(unit?: string) {
  return unit?.replace('gram', 'g').replace('stuk', '')
}
